const OFFER_TASK_LIST = 'https://webmaster.moneyfest-promo.ru/action2022/ActionPublic/calc';

export default class OfferTaskUrl {
    static get OFFER_TASK_LIST () {
        return OFFER_TASK_LIST;
    }
}
